export const sessionKey = 'sessionId'

export const LOGIN = 'LOGIN'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const USER_INFO_REQUEST = 'USER_INFO_REQUEST'
export const AVAILABLE_MODULES_REQUEST = 'AVAILABLE_MODULES_REQUEST'
export const SET_LOADING = 'SET_LOADING'
export const SET_AUTHORIZE = 'SET_AUTHORIZE'

export const LOCALE_PREFIX = 'services.authorization'
